import { useStore } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

const useCryptoCurrencyName = (currency: CryptoCurrencyEnum): string => {
  const [{ global }] = useStore();

  return global.currencies.config.display_options[currency]?.fullname || currency;
};

export default useCryptoCurrencyName;
